import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import { CircularProgress } from '@mui/material'

import { Button, Pagination } from 'components'
import { backgroundCheckSearchParams } from 'utils/constants/searchParams'
import { getBackgroundChecks, requestRecap } from 'services/apiKYP'
import { toast } from 'react-toastify'
import ExportButton from 'components/ExportButton'
import { REPORT_TYPE } from 'utils/constants/reportType'
import { useConfirm } from 'material-ui-confirm'
import styles from './styles'
import BackgroundCheckTable from '../../components/BackgroundCheckTable'
import BackgroundCheckSearchBar from '../../components/BackgroundCheckSearchBar'
import BackgroundCheckCreationForm from '../../components/BackgroundCheckTable/BackgroundCheckCreationForm'
import { hasPermissionScope } from '../../utils/functions'

const BackgroundCheck = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)

  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState(null)
  const [currentPage, setCurrentPage] = useState(0)
  const [size, setSize] = useState(10)
  const [itemsCount, setItemsCount] = useState(1)
  const [searchParams, setSearchParams] = useState(backgroundCheckSearchParams)
  const [requestingRecap, setRequestingRecap] = useState(false)
  const [exportRequested, setExportRequested] = useState(false)

  const [open, setOpen] = useState(false)
  const confirm = useConfirm()

  const runRecap = () => {
    requestRecap(token, searchParams)
      .then(() => {
        setRequestingRecap(true)
        toast.success('Reprocessamento solicitado com sucesso!')
      })
      .catch(() => {
        toast.error('Falha na solicitação!')
      })
      .finally(() => {
        setRequestingRecap(false)
      })
  }

  const handleAdd = () => {
    setOpen(true)
  }

  const handleRecap = () => {
    if (items.length === 0) {
      toast.warn(
        'Não há nenhum Background Check a ser reprocessado. Tente refinar a busca.',
      )
      return
    }

    confirm({
      title: 'Solicitar reprocessamento?',
      cancellationText: 'Cancelar',
      content: (
        <div className={classes.recapButtonDialog}>
          <span>
            Reprocessar Background Checks encontrados nessa busca?
          </span>
          <ul>
            <li>Apenas os casos com o status Processando serão considerados.</li>
            <li>
              O reprocessamento não criará novos Background Checks, apenas
              tentará destravar aqueles que não foram concluídos.
            </li>
          </ul>
        </div>
      ),
    }).then(runRecap).catch(() => null)
  }
  
  const getData = () => {
    setLoading(true)

    const options = {
      params: {
        page: currentPage + 1,
        size,
        ...searchParams,
        status: searchParams.status ? searchParams.status : null,
      },
    }

    getBackgroundChecks(token, options).then((response) => {
      const { data } = response
      setItems(data?.items)
      setItemsCount(data?.total)
    }).catch(() => {
      setItems([])
      setItemsCount(0)
    }).finally(() => {
      setLoading(false)
    })
  }

  const handleClose = () => {
    setOpen(false)
    getData()
  }
  const handleChangeSearchParams = (value) => {
    setSearchParams(value)
    setCurrentPage(0)
  }

  const handlePageChange = (event, page) => {
    setCurrentPage(page)
  }

  const handleChangeRowsPerPage = (event) => {
    setSize(event.target.value)
    setCurrentPage(0)
  }

  useEffect(() => {
    getData()
  }, [currentPage, size, searchParams])

  useEffect(() => {
    setExportRequested(false)
  }, [searchParams])

  return (
    <div className={classes.root}>
      <div className={classes.topBar}>
        <BackgroundCheckSearchBar setSearchParams={handleChangeSearchParams} />
        {
          hasPermissionScope(token, 'BG_CHECK_LIST') &&
          <Button
            loading={requestingRecap}
            onClick={handleRecap}
            title='Solicitar reprocessamento de BGCs com etapas de processamento pendentes.'
            disabled={requestingRecap}
          >
            Reprocessar
          </Button>
        }

          <ExportButton
            reportType={REPORT_TYPE.BACKGROUND_CHECK}
            searchParams={searchParams}
            setExportRequested={setExportRequested}
            disabled={exportRequested}
          />
        <Button onClick={handleAdd}>
          Adicionar
        </Button>
      </div>
      {loading ? (
        <div className={classes.loading}>
          <CircularProgress size={64} color='primary' />
          <span className={classes.loadingText}>
            Buscando background checks...
          </span>
        </div>
      ) : (
        <React.Fragment>
          <div className={classes.tableContainer}>
            <BackgroundCheckTable backgroundChecks={items} />
          </div>
          {items?.length > 0 && (
            <Pagination
              count={itemsCount}
              component='div'
              page={currentPage}
              rowsPerPage={size}
              rowsPerPageOptions={[10, 15, 20, 25, 30]}
              onPageChange={handlePageChange}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
          <BackgroundCheckCreationForm handleClose={handleClose} open={open} />
        </React.Fragment>
      )}
    </div>
  )
}

export default BackgroundCheck
